__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "postgrad-microcertificate-mf";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@descomplica/caching-browser", "1.0.5", function() { return function() { return __webpack_require__(2962); }; }, 1);
			register("@descomplica/microfrontend-core", "1.5.0-beta.1", function() { return function() { return __webpack_require__(5208); }; }, 1);
			register("@descomplica/microfrontend-react", "1.1.3-beta.1", function() { return __webpack_require__.e(716).then(function() { return function() { return __webpack_require__(4716); }; }); });
			register("@descomplica/settings-browser", "1.0.0", function() { return function() { return __webpack_require__(5013); }; }, 1);
			register("axios", "1.6.2", function() { return function() { return __webpack_require__(3024); }; }, 1);
			register("class-validator", "0.14.0", function() { return function() { return __webpack_require__(6225); }; }, 1);
			register("lottie-react", "2.4.0", function() { return Promise.all([__webpack_require__.e(741), __webpack_require__.e(989)]).then(function() { return function() { return __webpack_require__(9741); }; }); });
			register("mobx-react", "7.6.0", function() { return Promise.all([__webpack_require__.e(907), __webpack_require__.e(960), __webpack_require__.e(556)]).then(function() { return function() { return __webpack_require__(9444); }; }); });
			register("mobx", "6.12.0", function() { return function() { return __webpack_require__(4098); }; }, 1);
			register("react-dom", "18.2.0", function() { return Promise.all([__webpack_require__.e(164), __webpack_require__.e(416)]).then(function() { return function() { return __webpack_require__(4164); }; }); });
			register("react-router-dom", "6.3.0", function() { return Promise.all([__webpack_require__.e(111), __webpack_require__.e(116)]).then(function() { return function() { return __webpack_require__(2111); }; }); });
			register("react", "18.2.0", function() { return __webpack_require__.e(791).then(function() { return function() { return __webpack_require__(2791); }; }); });
			register("reflect-metadata", "0.1.13", function() { return __webpack_require__.e(121).then(function() { return function() { return __webpack_require__(6121); }; }); });
			register("tsyringe", "4.8.0", function() { return function() { return __webpack_require__(2389); }; }, 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};